import React, { useState } from 'react';
import Header from '../components/Header';
import Footer from '../components/Footer';
import { Button } from '../components/ui/button';
import { Input } from '../components/ui/input';
import { Textarea } from '../components/ui/textarea';
import { Card } from '../components/ui/card';
import { toast } from '../hooks/use-toast';
import { Mail, Phone } from 'lucide-react';

const ContactPage = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    message: '',
  });

  const handleSubmit = (e) => {
    e.preventDefault();
    
    if (!formData.name || !formData.email || !formData.message) {
      toast({
        title: 'Missing Information',
        description: 'Please fill in all fields.',
        variant: 'destructive',
      });
      return;
    }

    toast({
      title: 'Message Sent!',
      description: "Thank you for reaching out. I'll get back to you soon.",
    });

    setFormData({ name: '', email: '', message: '' });
  };

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  return (
    <div className="min-h-screen">
      <Header />
      <main className="pt-20">
        <section className="py-24 px-6 bg-[#5A6C73]">
          <div className="max-w-5xl mx-auto">
            {/* Section Header */}
            <div className="mb-16 text-center">
              <h1
                className="text-5xl md:text-6xl font-bold mb-4 text-white"
                style={{ fontFamily: 'DM Sans, sans-serif' }}
              >
                Have a design project
                <br />
                you need help with?
              </h1>
              <p className="text-white/90 text-lg">
                Let's collaborate and create something amazing together
              </p>
            </div>

            <div className="grid md:grid-cols-2 gap-12">
              {/* Contact Info */}
              <div className="space-y-6">
                <Card className="p-6 border-0 shadow-sm hover:shadow-md transition-shadow bg-white">
                  <div className="flex items-center gap-4">
                    <div className="w-12 h-12 rounded-full bg-[#EA8649]/10 flex items-center justify-center">
                      <Mail className="text-[#EA8649]" size={24} />
                    </div>
                    <div>
                      <p className="text-sm text-gray-600 mb-1">Email</p>
                      <a
                        href="mailto:ruchipatel17@icloud.com"
                        className="text-gray-900 font-medium hover:text-[#EA8649] transition-colors"
                      >
                        ruchipatel17@icloud.com
                      </a>
                    </div>
                  </div>
                </Card>

                <Card className="p-6 border-0 shadow-sm hover:shadow-md transition-shadow bg-white">
                  <div className="flex items-center gap-4">
                    <div className="w-12 h-12 rounded-full bg-[#EA8649]/10 flex items-center justify-center">
                      <Phone className="text-[#EA8649]" size={24} />
                    </div>
                    <div>
                      <p className="text-sm text-gray-600 mb-1">Phone</p>
                      <a
                        href="tel:+15153448885"
                        className="text-gray-900 font-medium hover:text-[#EA8649] transition-colors"
                      >
                        +1 (515) 344-8885
                      </a>
                    </div>
                  </div>
                </Card>

                <Card className="p-6 border-0 shadow-sm bg-white">
                  <p className="text-gray-700">
                    Feel free to reach out via email or phone. I'm always open to discussing new projects, 
                    creative ideas, or opportunities to be part of your vision.
                  </p>
                </Card>
              </div>

              {/* Contact Form */}
              <Card className="p-8 border-0 shadow-sm bg-white">
                <form onSubmit={handleSubmit} className="space-y-6">
                  <div>
                    <label htmlFor="name" className="block text-sm font-medium text-gray-700 mb-2">
                      Name
                    </label>
                    <Input
                      id="name"
                      name="name"
                      type="text"
                      placeholder="Your name"
                      value={formData.name}
                      onChange={handleChange}
                      className="w-full"
                    />
                  </div>

                  <div>
                    <label htmlFor="email" className="block text-sm font-medium text-gray-700 mb-2">
                      Email
                    </label>
                    <Input
                      id="email"
                      name="email"
                      type="email"
                      placeholder="your.email@example.com"
                      value={formData.email}
                      onChange={handleChange}
                      className="w-full"
                    />
                  </div>

                  <div>
                    <label htmlFor="message" className="block text-sm font-medium text-gray-700 mb-2">
                      Message
                    </label>
                    <Textarea
                      id="message"
                      name="message"
                      placeholder="Tell me about your project..."
                      value={formData.message}
                      onChange={handleChange}
                      className="w-full min-h-[150px]"
                    />
                  </div>

                  <Button
                    type="submit"
                    className="w-full bg-[#EA8649] hover:bg-[#d97640] text-white transition-colors"
                  >
                    Get In Touch
                  </Button>
                </form>
              </Card>
            </div>
          </div>
        </section>
      </main>
      <Footer />
    </div>
  );
};

export default ContactPage;